// src/pages/PaymentCancel.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
//import { useLocation } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
//import { useEffect } from "react";


const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    const savedQuote = localStorage.getItem("lastQuote");

  // ✅ store flag so Home can scroll even if router state is lost
  localStorage.setItem("returnToQuote", "true");

  if (savedQuote) {
    navigate("/", { state: { scrollToQuote: true } });
  } else {
    navigate("/");
  }


};




  const handleStartFresh = () => {
    localStorage.removeItem("lastQuote");
    navigate("/");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url('bg-taxi.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: 600,
          width: "100%",
          padding: "2rem",
          background: "rgba(255, 255, 255, 0.9)",
          borderRadius: "16px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#d9534f", marginBottom: "1rem" }}>❌ Payment Cancelled</h2>
        <p style={{ fontSize: "1.1rem", marginBottom: "1.5rem" }}>
          Your booking hasn’t been charged. You can return to your previous quote or start a new one.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
          <button
            onClick={handleGoBack}
            style={{
              background: "#ffc107",
              color: "#000",
              padding: "12px 24px",
              borderRadius: "8px",
              fontWeight: "600",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            🔁 Back to My Quote
          </button>

          <button
            onClick={handleStartFresh}
            style={{
              background: "#eee",
              color: "#333",
              padding: "12px 24px",
              borderRadius: "8px",
              fontWeight: "600",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            🗑 Start Fresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;

